import styled from 'styled-components';
const percentageSize = 1.3;

export const FilterWrapper = styled.div`
  border-top: 1px solid #666666;
  margin-top: 10px;
  /* padding-top: 5px; */
`;
export const FilterHeader = styled.div`
  display: flex;
  padding-left: 5px;
  justify-content: space-between;
`;
export const FilterTitle = styled.div`
  padding-top: 5px;

  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
`;
export const FilterOptObl = styled.div`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  margin: 15px 0 5px 0;
`;
export const FilterCloseButton = styled.button`
  background: none;
  border: none;
  /* padding-right: 6px; */
  cursor: pointer;
`;

export const FilterButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FilterButtons = styled.button`
  width: 50px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #333333;
  background-color: ${({ selected }) => (selected ? '#febf00' : '#666666')};
  border-radius: 3px;
  :hover {
    box-shadow: 0 0px 7px #febf00dd;
  }
`;

export const FilterValueInput = styled.input`
  width: 100%;
  color: white;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid;
  border-color: white;
  padding-left: 5px;
  padding-bottom: 5px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
  &:focus {
    outline: none;
  }
  ::placeholder,
  ::-webkit-input-placeholder {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: ${({ group }) => (group ? '#cccccc' : '#aaaaaa')};
  }
  :-ms-input-placeholder {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: ${({ group }) => (group ? '#cccccc' : '#aaaaaa')};
  }
  @media screen and (max-width: 468px) {
    height: 35px;
  }
`;
export const FilterConditionWrapper = styled.div`
  position: relative;
`;

export const FilterAddButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
`;

export const FilterAfegirButton = styled.button`
  margin-top: 10px;
  width: 50%;
  margin-right: 10px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background-color: ${({ group }) => (group ? '#333333' : '#666666')};
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
  border-radius: 3px;
  border-color: #666666;
  border-style: solid;
  :hover {
    box-shadow: 0 0px 7px #febf00dd;
  }
`;
export const FilterAfegirButtonSub = styled.button`
  margin-top: 10px;
  width: 50%;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background-color: ${({ group }) => (group ? '#333333' : '#666666')};
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
  border-radius: 3px;
  border-color: #666666;
  border-style: solid;
  :hover {
    box-shadow: 0 0px 7px #febf00dd;
  }
`;
export const FilterCercarButton = styled.button`
  margin-top: 10px;
  width: 50%;
  height: 32px;
  color: white;
  border: none;
  background-color: #666666;
  border-radius: 3px;
  opacity: ${({ canApply }) => (canApply ? '100%' : '25%')};
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
  font-weight: bold;
  :hover {
    box-shadow: ${({ canApply }) => (canApply ? '0 0px 7px #febf00dd' : 'none')};
  }
`;
export const FilterNetejarButton = styled.button`
  margin-top: 10px;
  width: 50%;
  height: 32px;

  color: #cccccc;
  background-color: transparent;
  border-radius: 3px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
  border-color: #cccccc;
  margin-right: 10px;
  border-style: solid;
  font-weight: bold;
  :hover {
    box-shadow: 0 0px 7px #febf00dd;
  }
`;
export const FilterOptions = styled.option`
  background-color: #666666;

  :hover {
    background-color: #333333;
  }
`;

export const FilterSubConditionWrapper = styled.div`
  /* border: 2px solid #cccccc; */
  border-radius: 3px;
  position: relative;
  padding: 10px;
  background-color: #666666;
`;

export const FilterSubConditionFilters = styled.div`
  /* display: flex;
  justify-content: space-evenly; */
  position: relative;
`;
export const FilterOperatorTextWrapper = styled.div`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
  width: 100%;
  margin: 10px 0;
  display: flex;
  justify-content: flex-end;
`;
export const FilterDeleteButton = styled.button`
  margin-top: 10px;
  background-color: ${({ group }) => (group ? '#333333' : '#666666')};
  border-radius: 3px;
  border: none;
  height: 22px;
  width: 22px;
  display: flex;
  align-content: center;
  justify-content: center;
  padding: 0;
`;

export const FilterSVG = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 512 512',
  width: 20,
  height: 20,
  fill: props.selected ? '#333333' : 'white'
}))``;

export const FilterAndOrButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 22px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;

  margin-right: 5px;
  border-width: 1px;
  color: ${({ selected }) => (selected ? '#333333' : 'white')};
  background-color: ${({ selected, group }) => (selected ? '#febf00' : group ? '#333333' : '#666666')};
  border-radius: 3px;
`;
export const FilterDeleteOperatorWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const FilterCatImg = styled.img`
  width: 24px;
`;

// export const FilterDataList = styled.datalist``;
// export const FilterDataListOption = styled.option``;

export const FilterDataList = styled.div`
  display: ${({ show }) => (show ? 'block' : 'none')};
  position: absolute;
  width: ${({ group }) => (group ? 'calc(100% - 20px)' : '100%')};
  z-index: 100;
  padding-left: 5px;
  border: 1px solid #333333;
  background-color: #666666;
  max-height: 90px;
  overflow-y: scroll;
  padding-top: 5px;

  ::-webkit-scrollbar {
    background-color: transparent;
    display: block;
    width: 7px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 1em;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 1em;
    margin: 2px;
  }

  ::-webkit-scrollbar-track-piece :end {
    background-color: transparent;
    margin-bottom: 10px;
    direction: ltr;
  }

  ::-webkit-scrollbar-track-piece :start {
    background-color: transparent;
    margin-bottom: 10px;
    direction: ltr;
  }

  ::-webkit-scrollbar-corner {
    background-color: transparent;
    direction: ltr;
  }
`;

export const FilterDataListOption = styled.div`
  width: 100%;
  background-color: ${({ isHover }) => (isHover ? '#333333' : 'none')};
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;

  color: white;
`;

export const FilterSelectorWrapper = styled.div`
  position: relative;
  margin: 10px;
  margin-left: 20px;
  display: flex;
  justify-content: space-between;
`;
export const FilterSelector = styled.div`
  width: 100%;
  height: 25px;
  padding-left: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #cccccc;

  @media screen and (max-width: 768px) {
    height: 35px;
  }
`;

export const FilterSelectedTitle = styled.div`
  color: white;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
`;

export const FilterOptionsContainer = styled.div`
  /* display: none; */
  position: absolute;
  z-index: 100;
  width: 100%;
  top: ${({ operator }) => (operator ? '50px' : '25px')};
  left: 0px;
  max-height: 160px;
  background-color: #666666;
  border: 1px solid #333333;
  overflow-y: scroll;

  @media screen and (max-width: 768px) {
    top: ${({ operator }) => (operator ? '70px' : '35px')};
    max-height: 120px;
  }

  ::-webkit-scrollbar {
    background-color: transparent;
    display: block;
    width: 7px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 1em;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 1em;
    margin: 2px;
  }

  ::-webkit-scrollbar-track-piece :end {
    background-color: transparent;
    margin-bottom: 10px;
    direction: ltr;
  }

  ::-webkit-scrollbar-track-piece :start {
    background-color: transparent;
    margin-bottom: 10px;
    direction: ltr;
  }

  ::-webkit-scrollbar-corner {
    background-color: transparent;
    direction: ltr;
  }
`;

export const FilterOptionWrapper = styled.div`
  display: flex;
  padding: 1px 5px;
  width: 100%;
  height: 20px;
  background-color: ${({ isHover, group }) => (isHover ? (group ? '#666666' : '#333333') : group ? '#333333' : '#666666')};
  cursor: pointer;

  align-items: center;
  justify-content: space-between;
  @media screen and (max-width: 768px) {
    height: 35px;
  }
`;

export const FilterOptionTitle = styled.div`
  color: white;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
`;
